import React, { useEffect, useState } from 'react';
import { TouchableOpacity, Text, Image, View } from 'react-native';
import globalStyles from '../styles/globalStyles';
import { formatDate } from '@/services/formatDate';
import { useGetPreviewImage } from '@/services/PDF/getPreviewImage';
import { Magazine } from '@/services/Datatypes';

interface PDFListItemProps {
    index: number;
    magazine: Magazine,
    filesize?: string,
    handleButtonPress: (magazine: Magazine) => void;
    handleDeleteButtonPress?: (magazine: Magazine) => void;
}

const PDFListItem: React.FC<PDFListItemProps> = ({
    index,
    magazine,
    filesize,
    handleButtonPress,
    handleDeleteButtonPress,
}) => {
    const getPreviewImage = useGetPreviewImage();
    const [previewImage, setPreviewImage] = useState<string>('');

    useEffect(() => {
        let isActive = true;
    
        const prepare = async () => {
            //console.log("ListItem_Magazine - magazine", magazine);
            const imagePath = await getPreviewImage(magazine);
            if (isActive) {
                setPreviewImage(imagePath);
            }
        };
    
        prepare();
    
        return () => {
            isActive = false; // Prevent state updates after unmount
        };
    }, [magazine, getPreviewImage]);


    return (
        <View style={{ width: '90%', alignSelf: 'center', paddingVertical: 10, }}>
            <TouchableOpacity
                style={globalStyles.ePaperSelectorButton}
                key={index}
                onPress={() => handleButtonPress(magazine)}
            >
                <Text style={globalStyles.ePaperSelectorinfo}>{formatDate(magazine?.date)} - {magazine?.edition}</Text>
                {previewImage && (
                    <Image source={{ uri: previewImage }} style={globalStyles.ePaperSelectorImage} />
                )}

                 {filesize && (
                    <Text style={globalStyles.ePaperSelectorinfoSmall}>Dateigröße: {filesize} MB</Text>
                )}
                {handleDeleteButtonPress && (
                    <TouchableOpacity
                        style={globalStyles.ePaperSelectorDeleteButton}
                        onPress={() => handleDeleteButtonPress(magazine)}
                    >
                        <Text style={globalStyles.ePaperSelectorDeleteButtonText}>Ausgabe lokal löschen</Text>
                    </TouchableOpacity>
                )}
            </TouchableOpacity>
        </View>
    );
};

export default PDFListItem;
